import type { HARRequest } from './mapHarEntryToHarRequest';
import { toTqlContext } from '../useTqlFilter';
import type { HttpRequestContext } from '../../utils/tql';

const stringifyHeaderValues = (
  headers: Record<string, string | string[]>,
): Record<string, string> => {
  const normalizedHeaders: Record<string, string> = {};
  for (const [key, value] of Object.entries(headers)) {
    normalizedHeaders[key] = Array.isArray(value) ? value.join(', ') : value;
  }
  return normalizedHeaders;
};

const stringifyMaybeJsonBody = (
  body: Record<string, unknown> | string | undefined,
): string | undefined => {
  if (body === undefined) {
    return undefined;
  }
  if (typeof body === 'string') {
    return body.length > 0 ? body : undefined;
  }
  return Object.keys(body).length > 0 ? JSON.stringify(body) : undefined;
};

export const harRequestToTqlContext = (
  request: HARRequest,
): HttpRequestContext =>
  toTqlContext({
    id: request.id,
    method: request.method,
    url: request.url,
    status: request.status,
    headers: stringifyHeaderValues(request.headers.request),
    body: stringifyMaybeJsonBody(request.requestBody),
    responseHeaders: request.headers.response
      ? stringifyHeaderValues(request.headers.response)
      : undefined,
    responseBody: stringifyMaybeJsonBody(request.responseBody),
    length: request.size,
    timestamp: request.timestamp,
  });
